import { render, staticRenderFns } from "./TransactionStatHistoryPage.vue?vue&type=template&id=1041f1fe&scoped=true&"
import script from "./TransactionStatHistoryPage.vue?vue&type=script&lang=js&"
export * from "./TransactionStatHistoryPage.vue?vue&type=script&lang=js&"
import style0 from "./TransactionStatHistoryPage.vue?vue&type=style&index=0&id=1041f1fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1041f1fe",
  null
  
)

export default component.exports